var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMintLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 34,
    viewBox: "0 0 130 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3868 7.22693V24.8778H38.2559V0H42.3868L52.5562 14.9009L62.7572 0H66.8881V24.8778H62.7572V7.22693L52.5404 22.0639L42.3868 7.22693ZM74.2038 0.000219663V24.878H70.0729V0.000219663H74.2038ZM81.4878 24.878H77.3569V0.000219663H81.6139L98.9256 18.6745V0.000219663H103.057V24.878H98.9256L81.4878 6.13981V24.878ZM119.139 24.878H115.008V3.70946H105.012V0.0322905H129.418V3.70946H119.139L119.139 24.878Z",
    fill: "#219653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9302 0.000488281L30.7648 12.9498C30.7648 17.6802 26.4731 25.4106 19.8575 25.4106L9.6374 25.5443C10.8506 23.9499 12.3441 22.1599 13.5078 20.633C19.9171 20.4591 24.4128 20.5445 25.7745 12.4019C26.0201 10.9337 25.8652 6.93401 25.8249 5.26528C24.5443 5.26325 12.3755 5.06132 11.4611 5.4008C6.62514 7.19489 5.67885 10.0831 5.4021 13.2577L5.1971 19.8418C6.49189 19.7747 15.5758 11.7288 20.3934 11.6712C12.5395 17.7073 9.54493 22.1251 0.0885543 34.0002C0.0451544 33.0106 -0.111429 13.5581 0.137412 12.4906C0.137412 7.78011 5.85747 0.122006 11.0393 0.122006L30.9302 0.000488281Z",
    fill: "#219653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintLogo);
export default __webpack_public_path__ + "static/media/mint_logo.80d682a12ac5693f5110d0c043683f4b.svg";
export { ForwardRef as ReactComponent };